import http from './http'

export default {
  get: frame => http.get(`/v2/appearances/${frame}`),
  update: (frame, data) => http.put(`/v2/appearances/${frame}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
    silent: true
  }),
  reset: frame => http.delete(`/v2/appearances/${frame}`, { silent: true }),
  deleteField: (frame, key) => http.delete(`/v2/appearances/${frame}/${key}`, { silent: true })
}



// WEBPACK FOOTER //
// ./src/services/api/appearances.js